<template>
  <form class="space-y-4" @submit.prevent="submit">
    <div>
      <label class="label">
        <span class="label-text">Email</span>
        <span class="text-error">*</span>
      </label>
      <FormField placeholder="Enter your email" widthClass="w-full" input-type="email" v-model="email"/>
    </div>

    <div>
      <label class="label">
        <span class="label-text">Password</span>
        <span class="text-error">*</span>
      </label>
      <FormField placeholder="Enter your password" widthClass="w-full" type="password" v-model="password"/>
    </div>

    <div class="text-right">
      <a href="#" class="text-error text-sm font-medium">Forgot password</a>
    </div>

    <button type="submit" class="btn btn-primary w-full mt-4" :disabled="loading">
      <span v-if="loading" class="loading loading-spinner loading-sm mr-2"></span>
      {{loading ? 'Logging in…' : 'Log in'}}
    </button>
  </form>
</template>

<script setup>
import FormField from "@/components/atoms/FormField.vue";

const email = defineModel('email')
const password = defineModel('password')
const emit = defineEmits(['submit'])

defineProps({
  loading: Boolean
})

const submit = () => {
  emit('submit')
}
</script>
